module.exports = __webpack_public_path__ + "media/excellusbcbs-app-page@sm-a73c9b04cfb1563f6f4388c1df7b7ceb.jpg";